export default __webpack_public_path__ + "static/GoogleCloud-d1f43bebf5e45a6f3d9533bca8624957.png";